import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";
import { borders, colors } from "@sonder/ui/source/styled/theme";

const Wrapper = styled.div`
  background: ${colors.white};
  border: ${borders.standard};
  box-sizing: border-box;
  height: min-content;
  margin-bottom: 0.714rem;
  padding: 1.714rem 2.286rem;
  width: 100%;
`;

export const SearchCardContentLoader = () => (
  <Wrapper data-testid="search-card-content-loader">
    <ContentLoader height={100} speed={2} viewBox="0 0 476 62" width={476}>
      <rect height="6" rx="3" ry="3" width="88" x="32" y="8" />
      <rect height="6" rx="3" ry="3" width="52" x="32" y="16" />
      <rect height="6" rx="3" ry="3" width="310" x="32" y="36" />
      <rect height="6" rx="3" ry="3" width="280" x="32" y="46" />
      <rect height="6" rx="3" ry="3" width="128" x="32" y="56" />
      <circle cx="10" cy="16" r="8" />
    </ContentLoader>
  </Wrapper>
);
